import script from "./LayerFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./LayerFiles.vue?vue&type=script&setup=true&lang=js"

import "./LayerFiles.vue?vue&type=style&index=0&id=4cc6fc1b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc6fc1b"]])

export default __exports__